export const scrollIntoViewWithOffset = (selector: HTMLElement, offset: number): void => {
  window.scrollTo({
    behavior: 'smooth',
    top:
      selector?.getBoundingClientRect().top -
      document.body.getBoundingClientRect().top -
      offset
  });
};
